const LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL || "debug";

const levels = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

const currentLevel = levels[LOG_LEVEL];

function log(level, ...args) {
  if (levels[level] < currentLevel) return;

  console[level](...args);
}

const logger = {
  debug: (...args) => log("debug", ...args),
  info: (...args) => log("info", ...args),
  warn: (...args) => log("warn", ...args),
  error: (...args) => log("error", ...args),
};

export default logger;
